'use strict';

var _ = require('lodash');
var TopAlertsTooltipFactory = function TopAlertsTooltipFactory(alertsDrawerService) {
  var HIDE_DELAY = 50;
  var SHOW_DELAY = 50;
  function TopAlertsTooltip() {}
  TopAlertsTooltip.constructor = TopAlertsTooltip;
  function getHtmlContent(cellData, wholeGridData) {
    var rowData = wholeGridData[cellData.row];
    return alertsDrawerService.getAlerts(rowData, 'FLIGHT_SCREEN', 'cabin', null).then(function (data) {
      var tooltipContent = _.template(require('../templates/top-alerts-tooltip.html'));
      var tooltipData = {
        'topAlertsData': _.slice(_.orderBy(data.rules, ['score'], ['desc']), 0, 3)
      };
      return tooltipContent(tooltipData);
    });
  }
  TopAlertsTooltip.prototype.getBuilder = function () {
    return function (cellData, wholeGridData) {
      if (cellData.value) {
        return {
          htmlContent: getHtmlContent(cellData, wholeGridData),
          hideDelay: HIDE_DELAY,
          showDelay: SHOW_DELAY,
          placement: 'top'
        };
      } else {
        return '';
      }
    };
  };
  return TopAlertsTooltip;
};
TopAlertsTooltipFactory.$inject = ['AlertsDrawerService'];
module.exports = TopAlertsTooltipFactory;